import { Moment } from "moment";
import 'moment/locale/de';
import 'moment/locale/es';
import 'moment/locale/nl';
import React, { useEffect, useState } from 'react';
import { InputGroup } from "react-bootstrap";
import Datetime from "react-datetime";
import { useAuth } from "./../../contexts/authContext";
import FormatUtils from './../../utils/FormatUtils.js';
import ControlFeedback from "./ControlFeedback";
import { ControlProps } from "./Types";

const DateControl: React.FC<ControlProps> = ({ name, value, disabled, width, validationResults, onChange, onBlur }) => {
    const { user } = useAuth();
    const [dateValue, setDateValue] = useState<Date>()

    let locale = 'en-GB'
    if (user && user.language)
        locale = user.language;

    useEffect(() => {
        let dateValue: Date | undefined = undefined;
        if (value) {
            const formatUtils = new FormatUtils();
            dateValue = formatUtils.dateFromString(value);

            if (dateValue === undefined || dateValue.toString() === 'Invalid Date')
                dateValue = value;
        }
        setDateValue(x => dateValue)
    }, [value])

    function onControlChange(val: string | Moment) {
        if (typeof val === 'string')
            onChange(val);
        else {
            if (val.toDate) {
                var formattedDateTime = new FormatUtils().formatDateTimeForStorage(val.toDate())
                onChange(formattedDateTime);
            }
        }
    }

    function getDateFormat(): string | undefined {
        switch (locale) {
            case "de-DE": return "DD.MM.YYYY";

            case "en-US": return "MM/DD/YYYY";

            case "en-GB":
            case "es-ES":
            case "nl-NL": return "DD-MM-YYYY";
        }

        return "DD-MM-YYYY";
    }

    function getPlaceholder(): string | undefined {
        if (disabled === true)
            return '';

        switch (locale) {
            case "de-DE": return "tt.mm.jjjj";
            case "en-US": return "mm/dd/yyyy";
            case "en-GB": return "dd-mm-yyyy";
            case "es-ES": return "dd-mm-aaaa"
            case "nl-NL": return "dd-mm-jjjj";
        }

        return "dd-mm-yyyy";
    }

    /*
    let dateValue: Date | undefined = undefined;
    if (value) {
        const formatUtils = new FormatUtils();
        dateValue = formatUtils.dateFromString(value);

        if (dateValue === undefined || dateValue.toString() === 'Invalid Date')
            dateValue = value;
    }
    */
    const dateFormat = getDateFormat();

    let isValid = validationResults && validationResults.length > 0 ? false : true;


    let className = "";
    if (validationResults && validationResults.length > 0)
        className = "is-invalid";

    if (width === undefined)
        width = 160;

    return (
        <div style={{ minWidth: width, width: width }}>
            <InputGroup className={className}>
                <InputGroup.Text>
                    <i className="fa fa-calendar"></i>
                </InputGroup.Text>
                <Datetime
                    dateFormat={dateFormat}
                    timeFormat={false}
                    value={dateValue}
                    onChange={onControlChange}
                    onNavigate={onBlur}
                    locale={locale.toLowerCase()}
                    closeOnSelect={true}
                    className={className}
                    inputProps={{ disabled: disabled, placeholder: getPlaceholder() }}
                />
            </InputGroup>
            <ControlFeedback isValid={isValid} validationResults={validationResults}></ControlFeedback>
        </div>
    );
}
export default DateControl;
